export default "__VITE_ASSET__HPYimUm3__"